import { useQuery } from "react-query";
import axios from "infra/http";

function useTiposAreaComum() {
  return useQuery(
    `/v1/tipo-area-comum`,
    async () => {
      const { data } = await axios.get<
        { id: string; nome: string; icone: string | null; cor: string | null }[]
      >(`/v1/tipo-area-comum`);

      return data;
    },
    {
      cacheTime: 1000 * 60,
      staleTime: 1000 * 60,
    }
  );
}

export default useTiposAreaComum;
